import $ from 'jquery';
import FormValidator from './FormValidator';
import EC from './ExpressionComparator';
import 'bootstrap/dist/js/bootstrap';

class LoginController{
    constructor(){
        this.hasValidated =false;

        let validationFields = $('.doValidate');
        this.validator = new FormValidator(validationFields);

        this.addEventListeners();
    }

    addEventListeners = function(){
        let instance = this;

        $('.doValidate').on('change keyup',(function(e){
            if(instance.hasValidated){
                if($(this).hasClass('radio')){
                    instance.validator.validateRadioField(this);
                }else if($(this).attr('type') == 'checkbox'){
                    instance.validator.validateCheckbox(this);
                }else{
                    instance.validator.validateField(this);
                }
            }
        }));

        /****** sign up form submit ********/
        $('.signUpForm').submit(function(e){
            e.preventDefault();
            instance.clearGeneralErrorMessage();

            if(instance.validator.validate()){
                $('.btnSubmit').button('loading');
                instance.clearAllErrorMessages();

                var options = {
                    'email' : $('#email').val(),
                    'password' : $('#password').val()
                };

                $.post('./processLogin.php',options,function(data){
                    $('.btnSubmit').button('reset');

                    data = JSON.parse(data);
                    if(data.status=='success'){
                        window.location.href = '../my-home/';
                    }else if(data.status == 'loginError'){
                        instance.showGeneralErrorMessage(data.msg);
                    }else{
                        instance.handleValidationError(data);
                    }
                });
            }
            instance.hasValidated = true;
            return false;
        });


        /****** Forgot Password form submit ********/
        $('.forgotPasswordForm').submit(function(e){
            e.preventDefault();
            instance.clearGeneralErrorMessage();

            if(instance.validator.validate()){
                $('.btnSubmit').button('loading');
                instance.clearAllErrorMessages();

                var options = {
                    'email' : $('#email').val()
                };

                $.post('./processForgotPasswordEmail.php',options,function(data){
                    $('.btnSubmit').button('reset');

                    data = JSON.parse(data);
                    if(data.status=='success'){
                        //window.location.href = '../my-home/';
                        instance.showGeneralSuccessMessage(data.msg);
                    }else if(data.status == 'generalError'){
                        instance.showGeneralErrorMessage(data.msg);
                    }else{
                        instance.handleValidationError(data);
                    }
                });
            }
            instance.hasValidated = true;
            return false;
        });



        /****** Password RESET form submit ********/
        $('.passwordResetForm').submit(function(e){
            e.preventDefault();
            instance.clearGeneralErrorMessage();

            if(instance.validator.validate()){
                $('.btnSubmit').button('loading');
                instance.clearAllErrorMessages();

                var options = {
                    'password' : $('#password').val(),
                    'repeatPassword' : $('#repeatPassword').val(),
                    'i' : $('#i').val(),
                    'a' : $('#a').val()
                };

                $.post('./processPasswordReset.php',options,function(data){
                    $('.btnSubmit').button('reset');

                    data = JSON.parse(data);
                    if(data.status=='success'){
                        window.location.href = './';
                    }else if(data.status == 'generalError'){
                        instance.showGeneralErrorMessage(data.msg);
                    }else{
                        instance.handleValidationError(data);
                    }
                });
            }
            instance.hasValidated = true;
            return false;
        });
    }

    handleValidationError = function(data){
        let instance = this;
        let firstErrorElementID = null;
        data.errorFields.forEach(function(obj,index){

            for(var key in data.errorFields[index]){

                if(!firstErrorElementID) firstErrorElementID = key;

                var value = data.errorFields[index][key];

                var error_field = $('#'+key)[0];
                if(error_field.tagName.toLowerCase() === 'input'){
                    instance.validator.showError(error_field,value);
                }else if(error_field.tagName.toLowerCase() === 'div'){
                    instance.validator.showRadioError(error_field,value);
                }else if(error_field.tagName.toLowerCase() === 'select'){
                    instance.validator.showError(error_field,value);
                }else{
                    instance.validator.showError(error_field,value);
                }


                //var error_field = $(this[key+'_group']).find('.form-control')[0];
                //this.formValidator.showError(error_field,value);
            }
        });

        this.scrollToFirstErrorElement(firstErrorElementID);
    }

    scrollToFirstErrorElement = function(firstErrorElementID){
        var errorElementYPos = $('#'+firstErrorElementID).offset().top - 70;
        $("html, body").animate({ scrollTop: errorElementYPos + 'px' }, "fast");
    }
    clearAllErrorMessages = function(){
        $('.errorMessage').empty();
        this.clearGeneralSuccessMessage();
        this.clearGeneralErrorMessage();
    }

    showGeneralErrorMessage(msg){
        $('.generalErrorMsg').html(msg);
    }
    showGeneralSuccessMessage(msg){
        $('.successMsg').html(msg);
    }
    clearGeneralErrorMessage(msg){
        $('.generalErrorMsg').empty();
    }
    clearGeneralSuccessMessage(msg){
        $('.successMsg').empty();
    }
}

export default new LoginController();



// WEBPACK FOOTER //
// ./LoginController.js